import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { isSubscriptionShapeBookClub, isSubscriptionShapeDigitalService, isSubscriptionShapeSeries, isSubscriptionShapeSubscription, } from "../../subscription-plan/selectors/isSubscriptionShape.js";
import { getSubscriptionType } from "./getSubscriptionType.js";
export const getSubscriptionVariantTermsConditions = (subscription) => {
    const subscriptionType = getSubscriptionType(subscription);
    const isSeries = isSubscriptionShapeSeries(subscriptionType);
    const isBookSubscription = isSubscriptionShapeSubscription(subscriptionType);
    const isBookClub = isSubscriptionShapeBookClub(subscriptionType);
    const isDigitalService = isSubscriptionShapeDigitalService(subscriptionType);
    if (isDigitalService)
        return undefined;
    const TERMS_ID = isSeries
        ? CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.VARIANT.TERMS
        : isBookSubscription
            ? CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.VARIANT.TERMS
            : isBookClub
                ? CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.VARIANT.TERMS
                : undefined;
    if (!TERMS_ID)
        throw new Error(`Unsupported subscription shape for terms conditions - Sku ${subscription?.sku}`);
    const termsConditions = getComponentContentById(subscription.components, TERMS_ID);
    return termsConditions?.html;
};
